export const preliminarIncendioViviendaConfig = [
  {
    path: "/actuaciones/new/preliminares-incendio-vivienda/initial",
    pathName: "preliminares-incendio-vivienda",
    titulo: "ACTUACIONES PRELIMINARES - INCENDIO EN VIVIENDA",
    props: {
      formType: "preliminar-incendio-vivienda",
      actuacionType: "preliminares-incendio-vivienda",
    },
    nameOfRoute: "actuacion-initial",
  },
  {
    path: "/actuaciones/new/preliminares-incendio-vivienda/initial/denunciante",
    pathName: "preliminares-incendio-vivienda",
    titulo: "AFECTADOS",
    nameOfRoute: "actuacion-form-denunciante",
  },
  {
    path: "/actuaciones/new/preliminares-incendio-vivienda/initial/momento",
    pathName: "preliminares-incendio-vivienda",
    titulo: "FECHA, HORA y UBICACIÓN",
    nameOfRoute: "actuacion-form-momento",
  },
  {
    path: "/actuaciones/new/preliminares-incendio-vivienda/initial/acusado",
    pathName: "preliminares-incendio-vivienda",
    titulo: "VINCULADOS",
    nameOfRoute: "actuacion-form-acusado",
  },
  {
    path: "/actuaciones/new/preliminares-incendio-vivienda/initial/efectos",
    pathName: "preliminares-incendio-vivienda",
    titulo: "EFECTOS",
    nameOfRoute: "actuacion-form-efectos",
  },
];
